import { render, staticRenderFns } from "./ProduktZufallsgenerator.vue?vue&type=template&id=3c55e44c&scoped=true&"
import script from "./ProduktZufallsgenerator.vue?vue&type=script&lang=js&"
export * from "./ProduktZufallsgenerator.vue?vue&type=script&lang=js&"
import style0 from "./ProduktZufallsgenerator.vue?vue&type=style&index=0&id=3c55e44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55e44c",
  null
  
)

component.options.__file = "ProduktZufallsgenerator.vue"
export default component.exports